const a={hasHolderName:!0};export{a as default};
//# sourceMappingURL=defaultProps.js.map
